import React from 'react'

import { FaLinkedin, FaFacebook } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { AiOutlineGooglePlus } from "react-icons/ai";

import "./TopStrip.css";

export default function TopStrip() {
  return (
    <>
      <div className="top-strip">
        <div className="ticker-container">
          <div className="ticker-text">
                Shilpaa Electrical Infratech India Ltd | A Licenced Electrical Contractor 'A Grade' (Exceeding 33kv All Voltages)
          </div>
        </div>
        <div className="social-icons">
          <a href="https://www.linkedin.com/company/seiil/?viewAsMember=true" aria-label="LinkedIn">
            <FaLinkedin />
          </a>
          <a href="https://x.com/shilpaa_infra" aria-label="Twitter">
            <FaXTwitter />
          </a>
          <a href="#" aria-label="Facebook">
            <FaFacebook />
          </a>
          <a href="#" aria-label="Google Plus">
            <AiOutlineGooglePlus />
          </a>
        </div>
      </div>
    </>
  );
}
